import Vue from "vue";
import "./plugins/axios";
import "./plugins/element.js";
import App from "./App.vue";

import "./plugins/zhiwi.js";
import "./utils/media.js";


//animate 动画库
import wow from "wowjs";
import "wowjs/css/libs/animate.css";
Vue.prototype.$wow = wow;

// import 'jiantest666/jiantest.css'

// import jianbutton from 'jiantest666'
// Vue.use(jianbutton)
// import jianinput from 'jiantest666'
// Vue.use(jianinput)

import jiantest666 from "jiantest666";
Vue.use(jiantest666);

import router from "./router";

import Print from "vue-print-nb";
Vue.use(Print);

import store from "./store";

//md5加密
import md5 from "js-md5";
Vue.prototype.$md5 = md5;
//xml转json
import X2js from "x2js";
Vue.prototype.$x2js = new X2js();

//编辑器
import QuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.snow.css";

// 复制文本
import clipboard from "clipboard";
Vue.prototype.clipboard = clipboard;
Vue.use(QuillEditor);

// 回到顶部
import BackTop from "./components/BackTop";
Vue.component("BackTop", BackTop);

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
